// 案件详情页面翻译（画布列表）
export default {
  // 页面标题
  pageTitle: "案件详情",

  // 顶部操作按钮
  buttons: {
    edit: "编辑",
    delete: "删除",
  },

  // 标签页
  tabs: {
    canvasAnalysis: "画布分析",
    dataBoard: "数据看板",
    surveyManage: "调证建议",
    surveyUser: "调证用户",
    addressMonitor: "地址监控",
    keyAddress: "关键地址",
    characterInfo: "人物信息",
    remarkManagement: "备注管理",
  },

  // 确认对话框
  confirmDialog: {
    deleteTitle: "删除确认",
    deleteMessage: "此操作将永久删除该画布, 是否确定?",
    confirmButton: "确定",
    cancelButton: "取消",
  },

  // 消息提示
  messages: {
    deleteSuccess: "删除成功",
    deleteCancelled: "已取消删除",
  },
};
